import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import {
  CATEGORY_LABELS,
  PAYMENT_METHOD_LABELS,
  VOUCHER_STATUS_LABELS,
} from '../../utils/cashierConstants';

/**
 * #235631 — trước đây thẻ này là một CỘT DỌC hẹp chiếm 1/3 bề ngang trang, đẩy bảng
 * phiếu chi vào 2/3 còn lại khiến nội dung chi bị xuống dòng vụn. Nay xếp NGANG thành
 * 4 khối, trả lại toàn bộ bề ngang cho bảng.
 */

const formatCurrency = (value) =>
  new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND', maximumFractionDigits: 0 }).format(
    Number(value || 0),
  );

const AMOUNT_STYLE = { fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' };

const StatRow = ({ label, amount, count }) => (
  <div className="d-flex justify-content-between small py-1 gap-2">
    <span className="text-muted text-truncate">{label}</span>
    <span style={AMOUNT_STYLE}>
      {formatCurrency(amount)} <span className="text-muted">({count})</span>
    </span>
  </div>
);

const StatGroup = ({ title, items, keyOf, labelOf }) =>
  items?.length > 0 ? (
    <Col xs={12} md={6} lg={3} className="mb-2 mb-lg-0">
      <h6 className="mb-2 small text-uppercase text-muted">{title}</h6>
      {items.map((item) => (
        <StatRow key={keyOf(item)} label={labelOf(item)} amount={item.amount} count={item.count} />
      ))}
    </Col>
  ) : null;

const VoucherStatsCard = ({ stats }) => (
  <Card>
    <Card.Header className="py-2">
      <h5 className="mb-0">Thống kê phiếu chi</h5>
    </Card.Header>
    <Card.Body>
      {!stats ? (
        <div className="text-muted small">Không có dữ liệu thống kê</div>
      ) : (
        <Row>
          <Col xs={12} md={6} lg={3} className="mb-2 mb-lg-0">
            <div className="p-3 bg-light rounded h-100">
              <div className="text-muted small">Tổng số tiền</div>
              <h4 className="mb-0" style={AMOUNT_STYLE}>{formatCurrency(stats.total_amount)}</h4>
              <div className="small text-muted">{stats.total_count} phiếu</div>
            </div>
          </Col>
          <StatGroup
            title="Theo trạng thái"
            items={stats.by_status}
            keyOf={(i) => i.status}
            labelOf={(i) => VOUCHER_STATUS_LABELS[i.status] || i.status}
          />
          <StatGroup
            title="Theo danh mục"
            items={stats.by_category}
            keyOf={(i) => i.category}
            labelOf={(i) => CATEGORY_LABELS[i.category] || i.category}
          />
          <StatGroup
            title="Theo hình thức"
            items={stats.by_payment_method}
            keyOf={(i) => i.payment_method}
            labelOf={(i) => PAYMENT_METHOD_LABELS[i.payment_method] || i.payment_method}
          />
        </Row>
      )}
    </Card.Body>
  </Card>
);

export default VoucherStatsCard;
